
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/[tag]",
      function () {
        return require("private-next-pages/journal/[tag]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journal/[tag]"])
      });
    }
  